export default {
    agencyPicture() {
        if (this.agency && this.agency.picture && !this.agency.picture.match(/base64/g)) {
            const baseUrl = process.env.VUE_APP_BASE_URL

            return `${baseUrl}${this.agency.picture}`
        }

        if (this.agency && this.agency.picture && this.agency.picture.match(/base64/g)) {
            return this.agency.picture
        }
    },

    agencyCover() {
        if (this.agency && this.agency.cover && !this.agency.cover.match(/base64/g)) {
            const baseUrl = process.env.VUE_APP_BASE_URL

            return `${baseUrl}${this.agency.cover}`
        }

        if (this.agency && this.agency.cover && this.agency.cover.match(/base64/g)) {
            return this.agency.cover
        }
    },

    cropperAspectRatio() {
        let ratio = 1

        if (this.croppingModel === 'cover') {
            ratio = 3.9
        }

        return ratio
    }
}
